import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';

import HomePage from './pages/HomePage';
import RoomPage from './pages/RoomPage';
import { initializeAuth } from './utils/authUtils';

const App: React.FC = () => {
    useEffect(() => {
        // Initialize Firebase Anonymous Auth when the app loads
        initializeAuth().catch((error) => {
            console.error('Failed to initialize authentication:', error);
        });
    }, []);

    return (
        <Router>
            <Switch>
                <Route exact path="/" component={HomePage} />
                <Route path="/room/:roomCode" component={RoomPage} />
                <Redirect to="/" />
            </Switch>
        </Router>
    );
};

export default App;
